module.exports = __webpack_public_path__ + "img/28f59e74b0657492ce2935a85c35b8d2.png";